import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '../components/UI/Button';

const RefundPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center">
          <Button 
            variant="ghost" 
            className="mr-4"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-3xl font-bold">Politique de Remboursement</h1>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 space-y-8">
          <section>
            <p className="text-gray-600 dark:text-gray-400">
              Nous souhaitons offrir à nos utilisateurs la meilleure expérience possible. Cette politique de 
              remboursement explique dans quels cas un remboursement peut être accordé.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Abonnements</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Nos services sont proposés sous forme d'abonnement mensuel ou annuel. Étant donné que l'accès au 
              service est accordé immédiatement après le paiement, aucun remboursement ne sera effectué pour des 
              périodes d'abonnement déjà entamées, sauf cas exceptionnel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Essai gratuit</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Certains plans peuvent proposer une période d'essai gratuite. Aucun montant ne sera prélevé tant 
              que l'utilisateur n'a pas souscrit volontairement à un plan payant.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Résiliation</h2>
            <p className="text-gray-600 dark:text-gray-400">
              L'utilisateur peut annuler son abonnement à tout moment depuis son espace personnel. La résiliation 
              prend effet à la fin de la période en cours. Aucun remboursement n'est effectué pour les jours non utilisés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Exceptions</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Des remboursements peuvent être envisagés dans les cas suivants :
            </p>
            <ul className="list-disc pl-6 mt-2 text-gray-600 dark:text-gray-400 space-y-2">
              <li>Problème technique grave empêchant totalement l'utilisation du service</li>
              <li>Double facturation ou erreur de paiement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Pour toute demande de remboursement</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Veuillez nous contacter à contact@invoice-ai.fr dans un délai de 7 jours suivant la transaction, 
              en expliquant la situation. Chaque demande sera examinée individuellement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Mode de remboursement</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Les remboursements, lorsqu'ils sont accordés, sont effectués via le mode de paiement d'origine 
              (ex. carte bancaire via Stripe).
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;